import * as queryString from 'query-string';

import { UrlParamKeys } from '../../app/UrlParamKeys';
import { IWorkbookDetailInfo } from '../../ts/models/IWorkbookInfo';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Helpers } from '../helpers/Helpers';
import { getQueryFromUrl } from '../helpers/UrlHelpers';
import { Module } from '../Module';
import { PublishWorkbookAction } from '../services/PublishWorkbookAction';
import { ISyncPublishResult } from './DatasourcePublishResultCtrl';

export class WorkbookPublishResultService {

  public static $inject = [
    '$rootScope',
    'PublishWorkbookAction',
    'AngularContextFactory'
  ];

  constructor(private $rootScope: ng.IRootScopeService,
              private PublishWorkbookAction: PublishWorkbookAction,
              private AngularContextFactory: AngularContextFactory) {
  }

  public handlePublishedWorkbook(workbookDetailInfo: IWorkbookDetailInfo, resultUrl: string) {
    const search = getQueryFromUrl(resultUrl);

    const publishResult: ISyncPublishResult = {
      isSyncAvailable: Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.SyncAvailable]),
      isSyncRunning: Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.SyncRunning]),
      remoteAgentWorkflowId: search[UrlParamKeys.RemoteAgentWorkflowId],
      publishedWithLQS: Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.PublishedWithLQS])
    };

    const publishedDatasourcesStr = search[UrlParamKeys.PublishedDataSources];
    const publishedDatasourceUrlNames = publishedDatasourcesStr ? publishedDatasourcesStr.split(',') : [];

    const publishedDatasourcesLqsStr = search[UrlParamKeys.PublishedDataSourcesWithLQS];
    const publishedDatasourceLQSUrlNames = publishedDatasourcesLqsStr ? publishedDatasourcesLqsStr.split(',') : [];

    const angularContext = this.AngularContextFactory.create(this.$rootScope.$new());

    this.PublishWorkbookAction.handlePublishedWorkbook(workbookDetailInfo, publishedDatasourceUrlNames, publishedDatasourceLQSUrlNames, publishResult, angularContext);
  }
}

Module.instance().service('WorkbookPublishResultService', WorkbookPublishResultService);
